/**
 * Custom JS - Dropdown menu hover handlers
 */
document.addEventListener('DOMContentLoaded', function() {
  var navItems = document.querySelectorAll('.nav-bar__linklist > .nav-bar__item');
  
  navItems.forEach(function(li) {
    var link = li.querySelector(':scope > a[aria-haspopup="true"]');
    if (!link) return;
    
    var menuId = link.getAttribute('aria-controls');
    var menu = document.getElementById(menuId);
    if (!menu) return;
    
    var closeTimer = null;
    
    li.addEventListener('mouseenter', function() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      // Close any other open dropdowns
      navItems.forEach(function(otherLi) {
        if (otherLi === li) return;
        var otherLink = otherLi.querySelector(':scope > a[aria-haspopup="true"]');
        if (!otherLink) return;
        var otherMenuId = otherLink.getAttribute('aria-controls');
        var otherMenu = document.getElementById(otherMenuId);
        if (otherMenu) {
          otherLink.setAttribute('aria-expanded', 'false');
          otherMenu.setAttribute('aria-hidden', 'true');
          otherLi.classList.remove('is-dropdown-open');
        }
      });
      // Open this dropdown
      link.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
      li.classList.add('is-dropdown-open');
    });
    
    li.addEventListener('mouseleave', function() {
      closeTimer = setTimeout(function() {
        link.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        li.classList.remove('is-dropdown-open');
      }, 150);
    });
  });
});
